import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, Observer, of } from 'rxjs';
import { SessionProvider } from './core/providers/session.provider';
import { TranslationRuntimeService } from './core/providers/translation-runtime.service';

@Injectable()
export class TranslationLoaderResolver {
  constructor(
    private translationRuntime: TranslationRuntimeService,
    private session: SessionProvider
  ) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> {
    const langCode = this.session.getCurrentLanguage() ?? 'hu-HU';
    const token = this.session.getToken();

    if (this.translationRuntime.isLoadedFor(langCode, token)) {
      return of(true);
    }

    return new Observable((observer: Observer<any>) => {
      this.translationRuntime.load(langCode, token).then(
        () => {
          observer.next(true);
          observer.complete();
        },
        (e) => {
          console.error(e);
          observer.next(true);
          observer.complete();
        }
      );
    });
  }
}
